// src/transactions/transactionDelete.js
import {
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

import { db } from "../../firebase/firebase";

export default async function deleteTransaction(txId) {
  try {
    const txRef = doc(db, "transactions", txId);
    const txSnap = await getDoc(txRef);
    if (!txSnap.exists()) return alert("Transaction not found");

    const tx = txSnap.data();

    // Step-1: Reverse account balance
    const accRef = doc(db, "accounts", tx.accountId);
    const accSnap = await getDoc(accRef);
    const acc = accSnap.data();

    const newBalance =
      Number(acc.currentBalance || 0) -
      Number(tx.amountIn || 0) +
      Number(tx.amountOut || 0);

    await updateDoc(accRef, { currentBalance: newBalance });

    // Step-2: Remove mirror tx (if exists)
    const mirrorSnap = await getDocs(
      query(
        collection(db, "transactions"),
        where("isMirror", "==", true),
        where(
          "description",
          "==",
          `Mirror of ${tx.expenseType || "Transaction"} - ${tx.accountName}`
        )
      )
    );

    if (!mirrorSnap.empty) {
      for (const m of mirrorSnap.docs) {
        const mData = m.data();

        const mAccRef = doc(db, "accounts", mData.accountId);
        const mAccSnap = await getDoc(mAccRef);
        const mAcc = mAccSnap.data();

        const newMirrorBalance =
          Number(mAcc.currentBalance || 0) -
          Number(mData.amountIn || 0) +
          Number(mData.amountOut || 0);

        await updateDoc(mAccRef, { currentBalance: newMirrorBalance });

        await deleteDoc(doc(db, "transactions", m.id));
      }
    }

    // Step-3: Delete original transaction
    await deleteDoc(txRef);

    alert("✅ Transaction & mirror removed, balances corrected");
    window.location.reload();
  } catch (err) {
    console.error("❌ Delete Error:", err);
    alert(err.message);
  }
}
